module.exports = __webpack_public_path__ + "static/img/yellow-poster.a99e6c0f.jpg";